// Types
import { GetNotReviewedAnyAiClipCandidates_getNotReviewedAnyAiClipCandidates as AnyAiClipCandidate } from 'api/interview/types/GetNotReviewedAnyAiClipCandidates';

/** The clipper names interview and post clips itself; only an unnamed one needs a fallback. */
export const getAiClipTitle = (
  candidate: AnyAiClipCandidate,
  index: number
): string => candidate.title?.trim() || `AI Clip #${index}`;

export const getAiClipExcerpt = (candidate: AnyAiClipCandidate): string =>
  candidate.transcriptExcerpt?.trim() || candidate.description?.trim() || '';
